import { Button } from '@mui/material';
import { useFormik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getEventByIdFn, patchEventFn, postEventFn } from 'Services/Event';
import CustomDateInput from 'Shared/CustomDateInput';
import CustomInput from 'Shared/CustomInput';
import ImageInput from 'Shared/ImageInput';
import RichTextEditor from 'Shared/RichTextEditory';

const AddUpdateEvent = () => {
    const navigate = useNavigate();
    const { id, status } = useParams();

    const { data: response } = useQuery({
        queryKey: ['get-event-by-id', id, status],
        queryFn: () => getEventByIdFn(id),
        enabled: !!id && status === "update"
    });
    const data = response?.data?.data;

    const { mutate: post } = useMutation(postEventFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/event/');
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    });

    const { mutate: patch } = useMutation(patchEventFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/event/');
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    });

    const start_date = new Date(data?.start_date);
    const end_date = new Date(data?.end_date);

    // eslint-disable-next-line no-extend-native
    Date.prototype.newDateFormat = function () {
        const year = this.getFullYear();
        const month = (this.getMonth() + 1).toString().padStart(2, '0');
        const day = this.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const initialValues = {
        title: data?.title || "",
        description: data?.description || "",
        start_date: start_date.newDateFormat() || "",
        end_date: end_date.newDateFormat() || "",
        location: data?.location || "",
        image: ""
    };

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: (values) => {
            console.log(values);
            if (!values.title) return toast.error("Title is required.");
            if (!values.description) return toast.error("Description is required.");
            if (!values.start_date) return toast.error("Start date is required.");
            if (!values.end_date) return toast.error("End date is required.");
            if (!values.location) return toast.error("Location is required.");

            const formData = new FormData();
            formData.append('title', values.title);
            formData.append('description', values.description);
            formData.append('start_date', values.start_date);
            formData.append('end_date', values.end_date);
            formData.append('location', values.location);

            if (status === 'add') {
                if (!values.image) return toast.error("Image is required.");
                formData.append('image', values.image);
                post(formData);
            } else {
                if (values.image) formData.append('image', values.image);
                formData.append("event_id", id);
                patch(formData);
            }
        }
    });

    return (
        <div className="p-4">
            <form
                className="bg-white shadow-md rounded-lg mx-auto p-6 flex flex-col gap-6"
                onSubmit={formik.handleSubmit}
            >
                <p className="text-xl text-black font-bold text-center">
                    {status === "update" ? "Update" : "Add"} Event
                </p>
                <CustomInput formik={formik} label="Title" name="title" />
                <CustomInput formik={formik} label="Loaction" name="location" />
                <div className='grid grid-cols-2 gap-4'>
                    <CustomDateInput formik={formik} label={"Start Date"} name={"start_date"} />
                    <CustomDateInput formik={formik} label={"End Date"} name={"end_date"} />
                </div>
                <ImageInput formik={formik} label="Image" name="image" />
                <RichTextEditor formik={formik} label={"Description"} name={"description"} />
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                >
                    {status === "update" ? "Update" : "Add"}
                </Button>
            </form>
        </div>
    );
};

export default AddUpdateEvent;
